// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { RugPopupStyleInterface, XngOverlayType } from "@rugby/App/Components/Tippy/Interface";
import { constants } from "@rugby/XDL/constants";
import { screen } from "@rugby/XDL/Helpers";
import Close from "@rugby/XDL/Icons/Close";
import { color, MediaQuery } from "@rugby/XDL/Utilities";
import styled, { css } from "styled-components";

const mobileStyle = css`
    ${MediaQuery.lte("md")} {
        div[data-tippy-root] {
            height: 100vh;
            left: 0 !important;
            right: unset !important;
            top: 0;
            bottom: 0;
            transform: translate3d(0, 0, 0) !important;
            width: 80%;
            max-width: 400px;
            min-width: 300px;
        }

        .tippy-content {
            background: ${getColor("common.white")};
            height: 100vh;
        }
    }
    ${MediaQuery.lt("md")} {
        .tippy-content {
            padding: 0;
            & > div {
                height: 100%;
            }
        }
    }
`;

export const rugPopupStyles: RugPopupStyleInterface = {
    main: {
        css: css`
            .tippy-box {
                transition-duration: 500ms !important;
                background-color: ${getColor("common.white")};
                box-shadow: 0 0 15px 0 ${color("secondary.main", 0.25)};
                color: ${getColor("text.main")};
                border-radius: 0;
                &:focus,
                > *:focus {
                    outline: none;
                }
            }
            .tippy-arrow {
                color: ${getColor("common.white")};
            }

            // icon-size
            .tippy-box > .tippy-arrow::before {
                // transform: scale(1);
            }

            .content-wrapper {
                padding: ${constants.xngPopup.desktopPadding}px 30px;
                ${screen("lte", "sm")`
                    padding:0;
                `};
            }
            .tippy-content {
                padding: 0;
            }

            ${(props: any) => (props.enableMobileMode ? mobileStyle : "")}

            // Custom theme
            .tippy-box[data-theme~="large-arrow"] > .tippy-arrow::before {
                transform: scale(1.9);
                filter: drop-shadow(0 -2px 2px ${color("secondary.main", 0.25)});
            }
        `,
    },
    elementWrapper: { outline: "none !important" },
    closeButton: {
        color: "secondary",
        src: Close,
        css: css`
            position: absolute;
            right: 10px;
            top: 10px;
            cursor: pointer;
            height: 12px;
            width: 12px;

            &:hover {
                color: ${color("secondary", 0.8)};
            }

            ${screen("lte", "sm")`
                z-index: 1;
                right: 20px;
                top: 30px;
                height: 15px;
                width: 15px;
            `};
        `,
    },
};

export const StyledPopupHeader = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${color("text.main")};
    font-size: 28px;
    line-height: 30px;
    margin-bottom: 20px;
    text-transform: capitalize;

    ${MediaQuery.lt("md")} {
        background: ${color("primary.main")};
        color: ${color("common.white")};
        font-size: 18px;
        padding: 20px;
    }
`;
